var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobinhoodChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0B0B0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 5.2C13.4 5.6 10.3 8.1 8.9 12.1L7.6 15.9C7.4 16.5 7.9 17 8.4 16.7L10.1 15.6C10.4 15.4 10.6 15.1 10.7 14.8L11.2 13.4H13.4C13.8 13.4 14.1 13.2 14.2 12.8L14.5 11.9H12L12.3 11.1C13.2 8.9 15.1 7.1 17.4 6.4C17.9 6.2 18.1 5.2 17.6 5.2Z",
    fill: "#CCFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 17.8L6.2 18.8",
    stroke: "#CCFF00",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobinhoodChain);
export default __webpack_public_path__ + "static/media/robinhood-chain.0fd69ea43a5082fd34e5f71f8d01b188.svg";
export { ForwardRef as ReactComponent };